/**
 * Ícones que as seções oferecem (benefícios, por exemplo). Chave estável: a vitrine
 * desenha cada uma (`apps/shop/src/themes/icons.tsx`), o editor mostra o rótulo.
 * Neutros, para qualquer segmento.
 */
export const THEME_ICONS = {
    truck: 'Entrega',
    shield: 'Segurança',
    card: 'Pagamento',
    return: 'Troca',
    chat: 'Atendimento',
    star: 'Qualidade',
    gift: 'Presente',
    clock: 'Rapidez',
    leaf: 'Natural',
    heart: 'Cuidado',
    tag: 'Preço',
    check: 'Garantia',
    phone: 'Telefone',
    pin: 'Localização',
    lock: 'Privacidade',
    calendar: 'Agendamento',
    box: 'Pedidos',
    user: 'Conta',
    store: 'Loja física',
    mail: 'E-mail',
};
//# sourceMappingURL=icons.js.map